<template>
    <div class="mapa bordas">
        <alerts />

        <p v-if="listagem.length < 1" class="text-muted">Nenhum leito encontrado com este filtro no momento.</p>

        <div class="mapa-leitos">

            <leito-transferencia v-if="leitoTransferencia != null" />
            <i v-if="leitoTransferencia != null" class="fa fa-long-arrow-right text-danger" aria-hidden="true" style="align-self: center;"></i>

            <leitos 
                v-for="(leito, index) in listagem"
                :key="index"
                :dados="leito"
                :index="index"
                @clicar="acoesLeito"
            />

            <b-modal
                no-close-on-backdrop
                id="modal-internacao-paciente"
                ref="modalInternacaoPaciente"  centered
                @hidden="leitoSelecionado = null"
                title="Admissão do Paciente"
                :hide-footer="true"
                >
                <internacao-paciente v-if="leitoSelecionado" :dados="leitoSelecionado"  @internar="internarPaciente" />
            </b-modal>

            <b-modal
                no-close-on-backdrop
                id="modal-alta-hospitalar"
                ref="modalAltaHospitalar" centered
                @hidden="leitoSelecionado = null"
                title="Registrar Saída"
                :hide-footer="true"
                >
                <alta-hospitalar v-if="leitoSelecionado" :dados="leitoSelecionado" @alta="realizarAlta" @fechar="$refs.modalAltaHospitalar.hide()" />
            </b-modal>

            <b-modal
                no-close-on-backdrop
                id="modal-impedir-leito"
                ref="modalImpedirLeito" centered
                @hidden="leitoSelecionado = null"
                title="Impedir Leito"
                :hide-footer="true"
                >
                <impedir-leito v-if="leitoSelecionado" :dados="leitoSelecionado" @impedir="impedirLeito" />
            </b-modal>

            <b-modal
                no-close-on-backdrop
                id="modal-liberar-leito"
                ref="modalLiberarLeito" centered
                @hidden="leitoSelecionado = null"
                title="Liberar Leito"
                :hide-footer="true"
                >
                <liberar-leito v-if="leitoSelecionado" :dados="leitoSelecionado" @liberar="liberarLeito" />
            </b-modal>

            <b-modal
                no-close-on-backdrop
                id="modal-transferir-leito"
                ref="modalTransferirLeito" centered
                @hidden="leitoSelecionado = null"
                title="Transferir leito na mesma unidade"
                :hide-footer="true"
                >
                <transferir-leito v-if="leitoSelecionado" :dados="leitoSelecionado" @transferir="transferirLeito" />
            </b-modal>

            <b-modal
                no-close-on-backdrop
                id="modal-ceder-leito"
                ref="modalCederLeito" centered
                @hidden="leitoSelecionado = null"
                title="Ceder Leito para a Central de Regulação"
                :hide-footer="true"
                >
                <ceder-leito v-if="leitoSelecionado" :dados="leitoSelecionado" @ceder="cederLeito" />
            </b-modal>

            <b-modal
                no-close-on-backdrop
                id="modal-reservar-leito"
                ref="modalReservarLeito" centered
                @hidden="leitoSelecionado = null"
                title="Reservar Leito"
                :hide-footer="true"
                >
                <reservar-leito v-if="leitoSelecionado" :dados="leitoSelecionado" @reservar="reservarLeito" />
            </b-modal>

            <b-modal
                no-close-on-backdrop
                id="modal-cancelar-internar-reserva-leito"
                ref="modalCancelarInternarReservaLeito" centered
                @hidden="leitoSelecionado = null"
                title="Ações de Leito Reservado"
                :hide-footer="true"
                >
                <cancelar-internar-reserva-leito v-if="leitoSelecionado" :dados="leitoSelecionado" @cancelar="cancelarReserva" @internar="internarPaciente" />
            </b-modal>

            <b-modal
                no-close-on-backdrop
                id="modal-internacao-paciente-regulado"
                ref="modalInternacaoPacienteRegulado" centered
                @hidden="leitoSelecionado = null"
                title="Admissão de Paciente Regulado"
                :hide-footer="true"
                >
                <internacao-paciente-regulado v-if="leitoSelecionado" :dados="leitoSelecionado" @internar="internarPaciente" />
            </b-modal>

            <b-modal
                no-close-on-backdrop
                id="modal-gerar-aih"
                ref="modalGerarAih" centered
                @hidden="leitoSelecionado = null"
                title="Gerar AIH"
                :hide-footer="true"
                size="lg"
                >
                <gerar-aih v-if="leitoSelecionado" :dados="leitoSelecionado" @geraraih="gerarAih" />
            </b-modal>

            <b-modal
                no-close-on-backdrop                                                                                                                              
                id="modal-notificar-longa-permanencia"
                ref="modalNotificarLongaPermanencia" centered
                @hidden="leitoSelecionado = null"
                title="Notificação de Longa Permanência"
                :hide-footer="true"
                size="lg"
                >
                <notificar-lp v-if="leitoSelecionado" :dados="leitoSelecionado" @notifica="notificaLp"/>
            </b-modal>

            <b-modal
                no-close-on-backdrop             
                id="modal-editar-longa-permanencia"
                ref="modalEditarLongaPermanencia" centered
                @hidden="leitoSelecionado = null"
                title="Longa Permanência"
                :hide-footer="true"
                size="lg"
                >
                <editar-lp v-if="leitoSelecionado" :dados="leitoSelecionado" @editar="editaLp"/>
            </b-modal>

             <b-modal
                no-close-on-backdrop                                                                                                                              
                id="modal-notificar-covid19"
                ref="modalNotificarCovid19" centered
                @hidden="leitoSelecionado = null"
                title="Notificação de Suspeita de COVID-19"
                :hide-footer="true"
                >
                <notificar-covid v-if="leitoSelecionado" :dados="leitoSelecionado" @notifica="notificaCovid" @editar="editaCovid"/>
            </b-modal>

            <b-modal
                no-close-on-backdrop                                                                                                                              
                id="modal-editar-covid19"
                ref="modalEditarCovid19" centered
                @hidden="leitoSelecionado = null"
                title="Editar Suspeita de COVID-19"
                :hide-footer="true"
                >
                <editar-covid v-if="leitoSelecionado" :dados="leitoSelecionado" @editar="editaCovid"/>
            </b-modal>

            <b-modal
                no-close-on-backdrop                                                                                                                              
                id="modal-editar-covid19"
                ref="modalAcompanhamento" centered
                @hidden="leitoSelecionado = null"
                title="Acompanhamento de Paciente"
                :hide-footer="true"
                >
                <acompanhamento v-if="leitoSelecionado" :dados="leitoSelecionado" @registro="registraAcompanhamento" />
            </b-modal>

            <b-modal
                no-close-on-backdrop
                id="modal-paciente-desconhecido"
                ref="modalPacienteDesconhecido"  centered
                @hidden="leitoSelecionado = null"
                title="Atualizar paciente desconhecido"
                :hide-footer="true"
                >
                <paciente-desconhecido v-if="leitoSelecionado" :dados="leitoSelecionado"  @atualizar="atualizaPacienteDesconhecido" />
            </b-modal>

            <vue-modality
                ref="modalsucesso"
                success
                centered
                hide-header
                ok-title="Fechar"
                @ok="$refs.modalsucesso.hide()"
                hide-cancel
            >
                  <span v-if="error != null" class="mt-4">{{error.msg}}</span>
            </vue-modality>

            <vue-modality
                ref="modalerror"
                error
                centered
                hide-header
                ok-title="Fechar"
                @ok="$refs.modalerror.hide()"
                hide-cancel
            >
                  <span v-if="error != null" class="mt-4">{{error.msg}}</span>
            </vue-modality>

        </div>

    </div>
</template>

<script>
import Alerts from './alerts/Alerts.vue'
import Leitos from './leitos/Leitos.vue'
import LeitoTransferencia from './leitos/LeitoTransferencia.vue'
import InternacaoPaciente from './modais/InternacaoPaciente.vue'
import AltaHospitalar from './modais/AltaHospitalar.vue'
import ImpedirLeito from './modais/ImpedirLeito.vue'
import LiberarLeito from './modais/LiberarLeito.vue'
import TransferirLeito from './modais/TransferirLeito.vue'
import CederLeito from './modais/CederLeito.vue'
import ReservarLeito from './modais/ReservarLeito.vue'
import InternacaoPacienteRegulado from './modais/InternacaoPacienteRegulado.vue'
import CancelarInternarReservaLeito from './modais/CancelarInternarReservaLeito.vue'
import GerarAih from './modais/GerarAih.vue'
import NotificarLp from './modais/NotificarLp.vue'
import EditarLp from './modais/EditarLp.vue'
import NotificarCovid from './modais/NotificarCovid.vue'
import EditarCovid from './modais/EditarCovid.vue'
import Acompanhamento from './modais/Acompanhamento.vue'
import PacienteDesconhecido from './modais/PacienteDesconhecido.vue'


export default {
    components: {
        Alerts,
        Leitos,
        InternacaoPaciente,
        AltaHospitalar,
        ImpedirLeito,
        LiberarLeito,
        LeitoTransferencia,
        TransferirLeito,
        CederLeito,
        ReservarLeito,
        InternacaoPacienteRegulado,
        CancelarInternarReservaLeito,
        GerarAih,
        NotificarLp,
        EditarLp,
        NotificarCovid,
        EditarCovid,
        Acompanhamento,
        PacienteDesconhecido
    },
    data () {
        return {
            horaAtual: '',
            leitoSelecionado: null
        }
    },
    computed: {
        error () {
            return this.$store.getters['sessao/getError']
        },
        listagemMapaLeitos () {
            // Listagem geral de leitos para a unidade
            // leitoStatus: 0=livre, 1=ocupado, 2=impedido, 3=cedido, 4 = regulado, 5 = reservado
            return this.$store.getters['leitos/getListagemMapaLeitos']
        },
        listagemFiltradaStatus () {
            // Filtros inseridos pelas ações da barra lateral PARA LISTAR SOMENTE DO TIPO ESPECIFICADO
            // SIDEBARLEFT => 0=Livres, 1=Ocupados, 2=Impedidos, 3=Cedidos,
            // 11=ocupados-longap(no clique: Notifica LongaP), 12=ocupados+longap(no clique: Editar LongaP) 13=Reservados (no clique: Cancelar/Internar Reserva)
            // 20-Ocupados (no clique, acompanhamento), 21-Ocupados-24h+

            // SIDEBARRIGHT => 22-Ocupados+desconhecidos (no clique, atualiza cadastro) 5=livres(no clique: Impedir Leito), 6=impedidos (no clique: Liberar Leitos -SidebarRight),
            // 7=ocupados(no clique: Transferir Leito - Etapa 1), 8=livres (no clique:  Transferir Leito - Etapa 2)
            // 9=livres(no clique: Ceder Leito), 10=ocupados(no clique: Gerar AIH), 14=Livres(no clique: Reservar Leito)
            return this.$store.getters['leitos/getListagemFiltradaStatus']
        },
        enfermariaSelecionada () {
            return this.$store.getters['filtro/getEnfermariaSelecionada']
        },
        filtroCodEnfermaria () {
            return this.$store.getters['filtro/getFiltroCodEnfermaria']
        },
        listagem () {
            let info = this.listagemMapaLeitos.dados
            if (this.enfermariaSelecionada != '') info = info.filter(i => i.leitoNomeEnfermaria == this.enfermariaSelecionada)
            if (this.filtroCodEnfermaria != '') info = info.filter(i => i.leitoCodigoEnfermaria == this.filtroCodEnfermaria)

            this.$store.commit('leitos/setListagemFiltrada', this.filtraStatus(info, this.listagemFiltradaStatus))
            return this.filtraStatus(info, this.listagemFiltradaStatus)
        },
        leitoTransferencia () {
            return this.$store.getters['transferir/getLeitoTransferencia']
        },
        unidadeSelecionada () {
            return this.$store.getters['filtro/getUnidadeSelecionada']
        },
    },
    watch: {
        error (value) {
            if (value != null && value.status == false) this.$refs.modalerror.open()
            if (value != null && value.status == true) this.$refs.modalsucesso.open()
        }
    },
    methods: {
        filtraStatus (dados, filtroStatus) {
            if (filtroStatus === null || filtroStatus === undefined) return dados     

            let livres = [0, 5, 8, 9, 14]
            let ocupados = [1, 7, 10, 11, 12, 15, 16, 20, 21, 22]
            let impedidos = [2, 6]
            let cedidosRegulados = [3, 17, 18]
            let reservado = [13]

            if (livres.includes(filtroStatus)) return dados.filter(i => i.leitoStatus == 0)
            else if (ocupados.includes(filtroStatus)) {
                switch (filtroStatus) {
                    case 1:
                    case 7:
                    case 10:
                    case 20:
                        return dados.filter(i => i.leitoStatus == 1)
                    case 11:
                        return dados.filter(i => i.leitoStatus == 1 && i.LongaPermanencia == '0')
                    case 12:
                        return dados.filter(i => i.leitoStatus == 1 && i.LongaPermanencia == '1')
                    case 15:
                        return dados.filter(i => i.leitoStatus == 1 && i.covid19 !== 1)
                    case 16:
                        return dados.filter(i => i.leitoStatus == 1 && i.covid19 === 1)
                    case 21:
                        return dados.filter(i => i.leitoStatus == 1 && this.controleTempoInternacao(i.DataHoraInternacao))
                    case 22:
                        return dados.filter(i => i.leitoStatus == 1 && i.pacienteCns.length < 15)
                }
            }
            else if (impedidos.includes(filtroStatus)) return dados.filter(i => i.leitoStatus == 2)   
            else if (reservado.includes(filtroStatus)) return dados.filter(i => i.leitoStatus == 5)   
            else if (cedidosRegulados.includes(filtroStatus)) {
                switch (filtroStatus) {
                    case 3:
                        return dados.filter(i => i.leitoStatus == 3 || i.leitoStatus == 4)
                    case 17:
                        return dados.filter(i => i.leitoStatus == 4)
                    case 18:
                        return dados.filter(i => i.leitoStatus == 3)
                }
            }
        },
        acoesLeito (value) {
            this.leitoSelecionado = value;
            let filtro = this.listagemFiltradaStatus
            switch (value.leitoStatus) {
                case 0:
                    this.acoesLeitoLivre(filtro)
                    break;
                case 1:
                    this.acoesLeitoOcupado(filtro)
                    break;
                case 2:
                    this.acoesLeitoImpedido(filtro)
                    break;
                case 4:
                    this.acoesLeitoRegulado(filtro)
                    break;
                case 5:
                    this.acoesLeitoReservado(filtro)
                    break;
            }
        },
        acoesLeitoLivre (filtro) {
            switch (filtro) {
                case 5:
                    this.$refs.modalImpedirLeito.show()
                    break;
                case 8:
                    this.$refs.modalTransferirLeito.show()
                    break;
                case 9:
                    this.$store.commit("ceder/setSexo", '')
                    this.$refs.modalCederLeito.show()
                    break;
                case 14:
                    this.$store.commit("consultas/setCnsInternacao", null)
                    this.$refs.modalReservarLeito.show()
                    break;
                default:
                    this.$store.commit("consultas/setCnsInternacao", null)
                    this.$refs.modalInternacaoPaciente.show()
            }
        },
        acoesLeitoOcupado (filtro) {
            switch (filtro) {
                case 7:
                    this.$store.commit('transferir/setLeitoTransferencia', this.leitoSelecionado)
                    this.leitoSelecionado = ''
                    this.$store.commit('leitos/setListagemFiltradaStatus', 8)
                    break;
                case 10:
                    this.$refs.modalGerarAih.show()
                    break;
                case 11:
                    this.$refs.modalNotificarLongaPermanencia.show()
                    break;
                case 12:
                    this.$store.dispatch('longapermanencia/pegaDadosPacienteLp', this.leitoSelecionado.internacaoId.toString()).then(() => {
                        this.$refs.modalEditarLongaPermanencia.show()
                    })
                    break;
                case 15:
                    this.$refs.modalNotificarCovid19.show()
                    break;
                case 16:
                    this.$refs.modalEditarCovid19.show()
                    break;
                case 20:
                    this.$refs.modalAcompanhamento.show()
                    break;
                case 22:
                    this.$refs.modalPacienteDesconhecido.show()
                    break;
                default:
                    this.$refs.modalAltaHospitalar.show()
            }
        },
        acoesLeitoImpedido (filtro) {
            switch (filtro) {
                default:
                    this.$store.commit("liberar/setMotivo", '')
                    this.$refs.modalLiberarLeito.show()
            }
        },
        acoesLeitoRegulado (filtro) {
            switch (filtro) {
                default:
                    this.$store.commit("consultas/setCnsInternacao", null)
                    this.$refs.modalInternacaoPacienteRegulado.show()
            }
        },
        acoesLeitoReservado (filtro) {
            switch (filtro) {
                default:
                    this.$refs.modalCancelarInternarReservaLeito.show()
            }
        },
        controleTempoInternacao (dt) {
            if (dt == '' || dt == null) return false

            let data = new Date(
                parseInt(dt.substr(6,4)),
                (parseInt(dt.substr(3,2)) - 1),
                parseInt(dt.substr(0,2)),
                parseInt(dt.substr(11,2)),
                parseInt(dt.substr(14,2))
            )

            let difdias =  86400000
            let diferenca = new Date().getTime() - data

            if (diferenca > difdias) return true
            else return false
        },
        internarPaciente (value) {
            this.$store.dispatch('internacao/internaPaciente', value).then(() => {
                this.$refs.modalInternacaoPaciente.hide()
                this.$refs.modalInternacaoPacienteRegulado.hide()
                this.$refs.modalCancelarInternarReservaLeito.hide()
                this.$store.commit('leitos/setListagemFiltradaStatus', null)
            })
        },
        realizarAlta (value) {
            this.$store.dispatch('altahospitalar/realizarAlta', value).then(() => {
                this.$refs.modalAltaHospitalar.hide()
                this.$store.commit('leitos/setListagemFiltradaStatus', null)
            })
        },
        impedirLeito (value) {
            this.$store.dispatch('impedimento/impedirLeito', value).then(() => {
                this.$refs.modalImpedirLeito.hide()
                this.$store.commit('leitos/setListagemFiltradaStatus', null)
            })
        },
        liberarLeito (value) {
            this.$store.dispatch('liberar/liberarLeito', value).then(() => {
                this.$refs.modalLiberarLeito.hide()
                this.$store.commit('leitos/setListagemFiltradaStatus', null)
            })
        },
        transferirLeito (value) {
            this.$store.dispatch('transferir/transferirLeito', value).then(() => {
                this.$refs.modalTransferirLeito.hide()
                this.$store.commit('transferir/setLeitoTransferencia', null)
                this.$store.commit('leitos/setListagemFiltradaStatus', null)
            })
        },
        cederLeito (value) {
            this.$store.dispatch('ceder/cederLeito', value).then(() => {
                this.$refs.modalCederLeito.hide()
                 this.$store.commit('leitos/setListagemFiltradaStatus', null)
            })
        },
        reservarLeito (value) {
            this.$store.dispatch('reservar/reservarLeito', value).then(() => {
                this.$refs.modalReservarLeito.hide()
                 this.$store.commit('leitos/setListagemFiltradaStatus', null)
            })
        },
        cancelarReserva (value) {
            this.$store.dispatch('reservar/cancelarReserva', value).then(() => {
                this.$refs.modalCancelarInternarReservaLeito.hide()
                 this.$store.commit('leitos/setListagemFiltradaStatus', null)
            })
        },
        gerarAih (value) {
            this.$store.dispatch('aih/gerarAih', value).then(() => {
                this.$refs.modalGerarAih.hide()
            })
        },
        notificaLp (value) {
            if (value.idCategoriaLongaPermanencia == '1') {
                this.$store.dispatch('longapermanencia/inserirCasoSocial', value).then(() => {
                    this.$refs.modalNotificarLongaPermanencia.hide()
                    this.$store.commit('leitos/setListagemFiltradaStatus', null)
                })
            }

            if (value.idCategoriaLongaPermanencia != '1') {
                this.$store.dispatch('longapermanencia/inserirOutros', value).then(() => {
                    this.$refs.modalNotificarLongaPermanencia.hide()
                    this.$store.commit('leitos/setListagemFiltradaStatus', null)
                })
            }
        },
        editaLp (value) {
            if (value.idCategoriaLongaPermanencia == '1') {
               this.$store.dispatch('longapermanencia/editarCasoSocial', value).then(() => {
                    this.$refs.modalEditarLongaPermanencia.hide()
                    this.$store.commit('leitos/setListagemFiltradaStatus', null)
                })
            }

            if (value.idCategoriaLongaPermanencia != '1') {
                this.$store.dispatch('longapermanencia/editarOutros', value).then(() => {
                    this.$refs.modalEditarLongaPermanencia.hide()
                    this.$store.commit('leitos/setListagemFiltradaStatus', null)
                })
            }
        },
        notificaCovid (value) {
            this.$store.dispatch('covid/notificarCovid', value).then(() => {
                this.$refs.modalNotificarCovid19.hide()
                this.$store.commit('leitos/setListagemFiltradaStatus', null)
            })
        },
        editaCovid (value) {
            this.$store.dispatch('covid/alterarCovid', value).then(() => {
                this.$refs.modalEditarCovid19.hide()
                this.$refs.modalNotificarCovid19.hide()
                this.$store.commit('leitos/setListagemFiltradaStatus', null)
            })
        },
        registraAcompanhamento(value) {
            this.$store.dispatch('leitos/acompanhar', value).then(() => {
                this.$refs.modalAcompanhamento.hide()
                this.$store.commit('leitos/setListagemFiltradaStatus', null)
            })
        },
        atualizaPacienteDesconhecido(value) {
             this.$store.dispatch('leitos/atualizarDesconhecido', value).then(() => {
                this.$refs.modalPacienteDesconhecido.hide()
                this.$store.commit('leitos/setListagemFiltradaStatus', null)
            })
        }
    }
}
</script>

<style>
    .mapa {
        background-color: #ffffff;
        flex-grow: 1;
        order: 3;
        padding: 20px 0;
        margin: 0;
        overflow-y: scroll;
        max-height: 562px;
    }

    .mapa-leitos {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
    }

    @media (min-width: 1154px) {
        .mapa {
            order: 2;
            margin: 0 20px;
        }

        .mapa-leitos {
            justify-content: flex-start;
        }
    }

    .display-leito {
        height: 66px;
        width: 50px;
        border-radius: 5px;
        margin: 6px;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #ffffff;
        cursor: pointer;
    }

    .cod_leito {
        font-weight: 700;
        font-size: 14px;
        display: block;
        text-align: center;
    }

    .cod_enfermaria {
        font-weight: 400;
        font-size: 14px;
        margin-right: 2px;
    }

    .icone_leito {
        width: 46px;
    }

    .longa-icone {
        position: relative;
        top: -12px;
        right: -30px;
        color: #fff;
        text-align: center;
        font-weight: 700;
        background-color: #de3341;
        width: 14px;
        font-size: 0.8rem;
        border-radius: 8px;
    }

    .dia-icone {
        position: relative;
        top: -12px;
        right: 0px;
        color: #fff;
        text-align: center;
        font-weight: 700;
        background-color: #de3341;
        width: 30px;
        font-size: 0.8rem;
        border-radius: 8px;
    }

    
    .covid-icone {
        position: relative;
        top: -12px;
        right: -30px;
        color: #fff;
        text-align: center;
        font-weight: 700;
        background-color: #451690;
        width: 14px;
        font-size: 0.8rem;
        border-radius: 8px;
    }
</style>
